<!--<mat-card *ngIf="ready; else progressSpinner">-->
<!-- TODO: Connect progress spinner (gets stuck if enabled at the moment) -->
<mat-card>
    <mat-card-header>
      <mat-card-title>{{pageType | capitalize}} Topic</mat-card-title>
    </mat-card-header>
    <form>
      <mat-card-content>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Display Name</mat-label>
          <input matInput [formControl]="topicForm.get('displayName')" required>
          <mat-error *ngIf="formService.controlHasError( topicForm.get('displayName'), 'required')">This field is required
          </mat-error>
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Strategy</mat-label>
          <input matInput name="strategy" [formControl]="topicForm.get('strategyName')" required>
          <mat-error *ngIf="formService.controlHasError( topicForm.get('strategyName'), 'required')">This field is required
          </mat-error>
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Subject</mat-label>
          <mat-select name="subject" [formControl]="topicForm.get('subject')"
                      required>
            <mat-option *ngFor="let subject of subjects" [value]="subject.name">{{ subject.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="formService.controlHasError( topicForm.get('subject'), 'required')">This field is required
          </mat-error>
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Tier 1</mat-label>
          <input matInput [formControl]="topicForm.get('tier1')" required>
          <mat-error *ngIf="formService.controlHasError( topicForm.get('tier1'), 'required')">This field is required
          </mat-error>
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Tier 2</mat-label>
          <input matInput [formControl]="topicForm.get('tier2')" required>
          <mat-error *ngIf="formService.controlHasError( topicForm.get('tier2'), 'required')">This field is required
          </mat-error>
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Tier 3</mat-label>
          <input matInput [formControl]="topicForm.get('tier3')" required>
          <mat-error *ngIf="formService.controlHasError( topicForm.get('tier3'), 'required')">This field is required
          </mat-error>
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Tier 4</mat-label>
          <input matInput [formControl]="topicForm.get('tier4')" required>
          <mat-error *ngIf="formService.controlHasError( topicForm.get('tier4'), 'required')">This field is required
          </mat-error>
        </mat-form-field>
      </mat-card-content>

      <mat-card-actions class="topic-actions" align="end">
        <button mat-raised-button color="primary" [disabled]="!topicForm.valid || isSubmitting" (click)="submitForm()">
          <!-- TODO: Connect to form and data model -->
          <!--{{ buttonName}}-->
          Submit
        </button>
      </mat-card-actions>
    </form>
</mat-card>

<!--<ng-template #progressSpinner>-->
  <!--<app-spinner></app-spinner>-->
<!--</ng-template>-->
